
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, Pipe, PipeTransform } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { Config } from 'src/app/app-constant';
import { ToastController } from '@ionic/angular';
import { DatePipe } from '@angular/common';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { AssestManagementComponent } from '../../assest-management/assest-management.component';
import { ElcmCreateEmailTempletComponent } from '../elcm-create-email-templet/elcm-create-email-templet.component';
import * as saveAs from 'file-saver';
import { environment } from 'src/environments/environment';
import { AddDeptLocComponent } from '../add-dept-loc/add-dept-loc.component';
// import { index } from 'd3';
import { MatSnackBar } from '@angular/material/snack-bar';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';

@Component({
  selector: 'app-elcm',
  templateUrl: './elcm.component.html',
  styleUrls: ['./elcm.component.scss'],
})
export class ElcmComponent implements OnInit {

  selectedTypeTabName: any = 'Dashboard';
  selectedTypeTabIndex: any = 0;
  buttonColorName: any;
  subModuleButtonColor: any | null;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any | null;
  loggedInUserEmpCode: any | null;
  loggedInUserId: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoles: any;
  loggedInUserName: any | null;
  loggedInUserRoleIsEmployee: boolean = false;
  originalData: any;
  showSetupPopup: boolean = false;
  competencyListManagerView: any;
  showImportPopup: boolean = false;
  selectedManagerDashboardId: boolean = false;
  selectedEmployeeDashboardId: any;
  selectedYearForCompetency: any = null;
  pmsYears: any = [];


  comparisonEmpIdsForSecondLast: any = [];
  selectedOption: any;
  selectedEmpYearonYear: any = [];
  selectedYearForGraphTwoHRAdmin: any = null;
  selectedYearForGraphFifthHRAdmin: any = null;
  selectedYearForGraphSix: any = null;
  selectedYearForGraphNineHRAdmin: any = null;
  selectedYearForGraphTenHRAdmin: any = null;
  weightageWiseCompetenciesGraphData: any[] = [];
  graphDataForLineGraph: any[] = [];
  selectedYearForGraphOneHRAdmin: any = null;
  fromYear: any = null;
  toYear: any = null;
  selectedOptionSalaryBreakUp: any;
  selectedcodecreateOption: any;
  signContent: any;
  letterContent: any;
  signfileName: any;
  signfileType: any;
  letterheadfileName: any;
  letterheadfileType: any;
  setLimit: any;
  setPrefix: any;
  selectedDeptLocation: any = null;
  selectedTypeTabNameForSetUp: any = "offerAndAppoinment";
  loggedInUserEmployeeCode: any;
  uniqueId: any;
  constructor(private datePipe: DatePipe, public sharedService: SharedService, private cdr: ChangeDetectorRef,
    private loader: LoaderService, private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog,
    private activatedroute: ActivatedRoute, private toastr: ToastrService,
    private toastController: ToastController,
    private cdRef: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<ElcmComponent>,
  ) {

  }

  ngOnInit() {




    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserEmployeeCode = sessionStorage.getItem('empCode');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }


    // this.getAllUser()
    this.getpmsyearlist();
  }

  tabTypeChanged(event: MatTabChangeEvent) {

    this.selectedTypeTabName = event.tab.textLabel;
    this.selectedTypeTabIndex = event?.index;


  }

  setuptabTypeChanged(event: MatTabChangeEvent) {
    this.selectedTypeTabNameForSetUp = event?.tab.textLabel;
    this.getpmsyearlist();
  }
  generateCode(prefix: string, limit: string, dept: string = '', location: string = ''): string {
    let code = prefix + limit; // Start with prefix and limit

    if (dept) {
      code += dept; // Add department if provided
    }

    if (location) {
      code += location; // Add location if provided
    }

    return code;
  }
  selectedTypeTabIndexForReport: any;
  selectedTypeTabNameForReport: any = 'dumpReport';
  tabTypeChangedForReport(event: MatTabChangeEvent) {

    this.selectedTypeTabNameForReport = event.tab.textLabel;
    this.selectedTypeTabIndexForReport = event?.index;


  }
  // ionViewWillEnter() {
  //   this.activatedroute.params.subscribe((params: any) => {
  //     var tab = params['tab'];
  //     var operation = params?.operation;
  // console.log(params);

  //     // If navigating back to ELCM or Setup, reset the index to 0
  //     if (tab === 'ELCM') {
  //       this.selectedTypeTabName = 'Dashboard';
  //       this.selectedTypeTabIndex = 0;  // Reset to the first tab (Dashboard)
  //     }

  //     if (tab === 'My Competency') {
  //       this.selectedTypeTabName = 'My Competency';
  //       this.selectedTypeTabIndex = 1;
  //     }

  //     if (operation === 'Setup') {
  //       if (['HR Admin', 'Super Admin', 'PHI Admin', 'MD'].includes(this.loggedInUserRole)) {
  //         this.showSetupPopup = true;
  //       }
  //     } else if (operation === 'import') {
  //       if (['HR Admin', 'Super Admin', 'PHI Admin', 'MD'].includes(this.loggedInUserRole)) {
  //         this.showImportPopup = true;
  //       }
  //     } else {
  //       if (['HR Admin', 'Super Admin', 'PHI Admin', 'MD'].includes(this.loggedInUserRole)) {
  //         // this.getDepartmentsByCompany();
  //       } else if (this.loggedInUserRole === 'Finance') {
  //         this.selectedManagerDashboardId = true; 
  //       } else {
  //         this.selectedEmployeeDashboardId = this.loggedInUserId;
  //         // this.getUserByID();
  //       }
  //     }
  //   });
  // }
  ionViewWillEnter() {

    this.activatedroute.params.subscribe((params: any) => {


      console.log(sessionStorage.getItem('sidebarNames'));

      let checkmoduleName: any = [];
      let storedData = sessionStorage.getItem('sidebarNames');

      if (storedData) {
        checkmoduleName = JSON.parse(storedData); // Convert JSON string to object
      }

      let modulename = checkmoduleName.filter((elm: any) => elm.moduleName == 'ELCM');

      var tab = modulename[0].moduleName;
      if (tab === 'ELCM') {
        this.selectedTypeTabName = 'Dashboard'
        this.selectedTypeTabIndex = 0;

      };

      if (params?.operation === 'Setup') {
        if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
          || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
          this.showSetupPopup = true;

          // this.getPmsYears();
        }
      } else if (params?.operation === 'import') {
        if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
          || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
          this.showImportPopup = true;
        }
      } else {
        if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
          || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
          // this.getDepartmentsByCompany();
        }
        else if (this.loggedInUserRole === 'Finance') {
          this.selectedManagerDashboardId = true; // Set up a manager-specific action
          // Call a manager-specific method if needed
        }

        else {
          this.selectedEmployeeDashboardId = this.loggedInUserId;

        }

      }
    });
  }

  empStatus: any = 1;
  reportingManager: any;
  getAllUser() {
    const request = {
      "search": '',
      "userType": null,
      "status": this.empStatus,
      "companyId": this.loggedInUserCompanyID,
      "loggedInUserRole": this.loggedInUserRole,
    }
    this.loader.simpleLoaderWithDuration();
    this.httpService.callPostService(this.config.searchEmployeeMaster + '?page=' + 0 + '&size=' + 100, request)
      .subscribe((data: any) => {
        this.loader.dismissLoader();

        console.log(data.data.users);
        let reportingManager = data.data.users.map((elm: any) => elm.reportingManagerCode);
        console.log(reportingManager);
        this.reportingManager = reportingManager.includes((this.loggedInUserEmployeeCode));
        this.httpService.reportingManagerForElcm = this.reportingManager;


      }, (error: any) => {
        this.loader.dismissLoader();
      }, () => { });
  }










  // getpmsyearlist() {
  //   this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
  //     this.pmsYears = [];
  
  //     // Convert year ranges from API response into "YYYY-YYYY" format
  //     data?.data?.yearRanges?.forEach((ele: any) => {
  //       let yearParts = ele.split('_'); 
  //       let formattedYear = `${yearParts[0]}-${yearParts[1]}`;
  //       this.pmsYears.push({ year: formattedYear });
  //     });
  
  //     // Get the current date
  //     const today = new Date();
  //     const currentYear = today.getFullYear();
  //     const currentMonth = today.getMonth(); // 0 = Jan, 11 = Dec
  //     let fiscalStartYear, fiscalEndYear;
  
  //     // Manage according to the selected fiscal year format
  //     switch (this.loggedInCompanyFiscalyear) {
  //       case 'Jan_Dec':
  //         fiscalStartYear = currentYear;
  //         fiscalEndYear = currentYear;
  //         break;
  
  //       case 'Apr_Mar':
  //         if (currentMonth < 3) { // Jan, Feb, Mar
  //           fiscalStartYear = currentYear - 1;
  //           fiscalEndYear = currentYear;
  //         } else {
  //           fiscalStartYear = currentYear;
  //           fiscalEndYear = currentYear + 1;
  //         }
  //         break;
  
  //       case 'July_Jun':
  //         if (currentMonth < 6) { // Jan to Jun
  //           fiscalStartYear = currentYear - 1;
  //           fiscalEndYear = currentYear;
  //         } else {
  //           fiscalStartYear = currentYear;
  //           fiscalEndYear = currentYear + 1;
  //         }
  //         break;
  
  //       case 'Oct_Sep':
  //         if (currentMonth < 9) { // Jan to Sep
  //           fiscalStartYear = currentYear - 1;
  //           fiscalEndYear = currentYear;
  //         } else {
  //           fiscalStartYear = currentYear;
  //           fiscalEndYear = currentYear + 1;
  //         }
  //         break;
  
  //       default:
  //         console.warn("Invalid Fiscal Year Format");
  //         return;
  //     }
  
  //     const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
  
  //     // Find and set the correct year from the available list
  //     this.pmsYears.forEach((ele: any) => {
  //       if (ele?.year === yearValue) {
  //         this.selectedYearForCompetency = ele?.year;
  //         this.selectedYearForGraphOneHRAdmin = ele?.year;
  //         this.selectedYearForGraphTwoHRAdmin = ele?.year;
  //         this.selectedYearForGraphFifthHRAdmin = ele?.year;
  //         this.selectedYearForGraphSix = ele?.year;
  //         this.selectedYearForGraphNineHRAdmin = ele?.year;
  //         this.selectedYearForGraphTenHRAdmin = ele?.year;
  
  //         let test = ele?.year.split('-');
  //         this.fromYear = test[0];
  //         this.toYear = test[1];
  //       }
  //     });
  
  //     // Additional function calls
  //     this.getAllEmployeeCodeData();
  //     this.getSalaryBreckUpData();
  //     this.getBAndAndGrade();
  //     this.getConfirmation();
  //     this.getUploadLetterHead();
  //     this.checkForSameHODORMANAGER();
  //   });
  // }
  



  
    getpmsyearlist() {
      this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
        this.pmsYears = formatYearRanges(data?.data?.yearRanges);
  
        const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
  
        const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
    
        this.setSelectedYear(yearValue);
      // Additional function calls
      this.getAllEmployeeCodeData();
      this.getSalaryBreckUpData();
      this.getBAndAndGrade();
      this.getConfirmation();
      this.getUploadLetterHead();
      this.checkForSameHODORMANAGER()
      });
    }
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele:any) => ele.year === yearValue);
    if (selectedYearObj) {
          this.selectedYearForCompetency = selectedYearObj?.year;
          this.selectedYearForGraphOneHRAdmin = selectedYearObj?.year;
          this.selectedYearForGraphTwoHRAdmin = selectedYearObj?.year;
          this.selectedYearForGraphFifthHRAdmin = selectedYearObj?.year;
          this.selectedYearForGraphSix = selectedYearObj?.year;
          this.selectedYearForGraphNineHRAdmin = selectedYearObj?.year;
          this.selectedYearForGraphTenHRAdmin = selectedYearObj?.year;
  
          let test = selectedYearObj?.year.split('-');
          this.fromYear = test[0];
          this.toYear = test[1];
    }
  }
  operation: any
  onClickSetup(operation: any) {
    this.operation = operation;
    this.router.navigate(['/home/hrportal/elcm', { operation: operation }]);

  }

  onClickback() {

    this.router.navigate(['/home/hrportal/elcm']);

  }
  onClickLogs(moduleName: any) {
    this.router.navigate(['/home/hrportal/asset-logs', { moduleName: moduleName, id: 0 }]);
  }
  getYearSetupForReimbursement() {

  }
  preventNegative(event: KeyboardEvent) {
    if (event.key === '-' || event.key === 'e' || event.key === '.') {
      event.preventDefault();
    }
  }

  getEmployeeCodeDataList: any = [];
  updateFlag: boolean | undefined;
  flagData: any = []
  getAllEmployeeCodeData() {
    // let formData = {

    //   "companyId": this.loggedInUserCompanyID,
    //   "changeByUserId":this.loggedInUserId,
    //   "year": this.selectedYearForCompetency


    // }


    this.httpService.callGetService(`${this.config.getAllEmployeeCode}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency}`).subscribe((resp: any) => {
      this.getEmployeeCodeDataList = [];
      this.selectedcodecreateOption = '';
      this.setPrefix = '';
      this.setLimit = '';
      if (resp.data) {

        this.getEmployeeCodeDataList = resp?.data[0];
        this.flagData = resp?.data;
        this.updateFlag = this.getEmployeeCodeDataList ? true : false;
        this.setPrefix = this.getEmployeeCodeDataList?.companyPrefix;
        this.setLimit = this.getEmployeeCodeDataList?.startNumber;
        this.selectedDeptLocation = this.getEmployeeCodeDataList?.employeeCodeSelection;
        this.selectedcodecreateOption = this.getEmployeeCodeDataList.isManual ? 'manual' : 'auto';

        this.httpService.setEmployeeCodeData(this.getEmployeeCodeDataList);
      }
    })
  }
  hasInvalidCode: boolean = false
  onSelectionChangeForWantLimit(event: any) {
    this.hasInvalidCode = this.probstionPriodsData?.some((bandItem: any) =>
      bandItem.grades.some((gradeItem: any) => gradeItem.probationId == null)
    );

    if (this.hasInvalidCode) {
      // Open the dialog without resetting selection initially
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: 'Probation period is required for all grades',
          btn2: 'OK',
          btn2BgColor: 'red',
          showSuccessIcon: false,
          showSuccessMessage: false
        }
      });

      // Handle the dialog result after it's closed
      dialogRef.afterClosed().subscribe((result: any) => {
        console.log(result);  // Logs the result of the dialog

        // Reset the selection after closing the dialog
        this.selectedcodecreateOption = null;

        // Trigger change detection to update the UI
        this.cdRef.detectChanges();
      });

      return;
    }


    // Proceed with confirmation dialog if no issue
    if (!this.hasInvalidCode) {
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: `Are you sure you want to select "${event}"?`,
          btn2: 'Yes',
          btn1: 'No',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false,
        },
      });

      dialogRef.afterClosed().subscribe((result) => {
        console.log(result);

        if (result) {
          this.selectedcodecreateOption = event;
          if (event === 'manual') {
            this.saveData();
          }
        } else {
          this.selectedcodecreateOption = null; // Reset selection
        }

        // Force UI refresh after setting value
        setTimeout(() => {
          this.cdRef.detectChanges();
        });
      });
    }
  }

  async showToast(message: string, color: string) {
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      color: color,
      position: 'top'
    });
    await toast.present();
  }
  

  // =====================================
  onSelectionChangesalaryAndAppoinment(selectedValue: string, event: Event) {
    event.preventDefault();
    event.stopPropagation();

    const previousSelection = this.selectedOptionSalaryBreakUp;

    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: `Are you sure you want to select "${selectedValue}"?`,
        btn2: 'Yes',
        btn1: 'No',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      
      if (result === true) {
       console.log(selectedValue);
       
        this.selectedOptionSalaryBreakUp = selectedValue;
        this.savesalaryinfo();
        return;
      } else {
        this.selectedOptionSalaryBreakUp = previousSelection;
      }
      this.getSalaryBreckUpData();
      this.cdRef.detectChanges();
    });
  }
 
  // =========================================================
  onSelectionChangeAppoinment(selectedValue: string, event: Event) {
    event.preventDefault();
    event.stopPropagation();

    const previousSelection = this.selectedOptionSalaryBreakUp;

    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: `Are you sure you want to select "${selectedValue}"?`,
        btn2: 'Yes',
        btn1: 'No',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      
      if (result === true) {
       console.log(selectedValue);
       
        this.selectedOptionForAppoinmentLetter = selectedValue;
        this.savesalaryinfo();
        return;
      } else {
        this.selectedOptionForAppoinmentLetter = previousSelection;
      }
      this.getSalaryBreckUpData();
      this.cdRef.detectChanges();
    });
  }
  selectedOptionForAppoinmentLetter: any;
  
  savesalaryinfo() {
    // Create base form data with common fields
    const baseFormData = {
 
      "isSalaryBreakup": this.selectedOptionSalaryBreakUp == 'Yes' ? true : false,
      "isAppointment": this.selectedOptionForAppoinmentLetter == 'Yes' ? true : false,
      "companyId": this.loggedInUserCompanyID
    };
  
    // Determine if creating new record or updating existing
    const isNewRecord = !this.updateSalarybreckupID;
    
    // Define endpoint and data based on operation type
    const endpoint = isNewRecord 
      ? `${this.config.salaryBrekUp}`
      : `${this.config.salaryBrekUpUpdate}/${this.updateSalarybreckupID}`;
    
    // Add additional fields only for new records
    const formData = isNewRecord 
      ? { 
          ...baseFormData, 
          "fiscalYear": this.loggedInCompanyFiscalyear,
          "year": this.selectedYearForCompetency
        } 
      : baseFormData;
    
    // Choose appropriate HTTP method
    const httpMethod = isNewRecord 
      ? this.httpService.callPostService 
      : this.httpService.callPutService;
  
    // Make API request
    httpMethod.call(this.httpService, endpoint, formData).subscribe((data: any) => {
      if (data) {
        this.showSuccessDialog(data.message);
      }
    });
  }
  
  // Extract dialog creation to a separate method
  private showSuccessDialog(message: string) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: message,
        btn2: 'OK',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: true,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    
    // Empty callback since we're not doing anything after dialog closes
    dialogRef.afterClosed().subscribe(() => {});
  }

  grtsalaryBreackUpdata: any = [];
  setupNotCompleted: any;
  updateSalarybreckupID: any
  getSalaryBreckUpData() {
    this.httpService.callGetService(`${this.config.getSalaryBrekUp}/${this.loggedInUserCompanyID}`,).subscribe((record: any) => {
      this.grtsalaryBreackUpdata = record.data
      let lastObjects = this.grtsalaryBreackUpdata.filter((elm: any) => elm.companyId == this.loggedInUserCompanyID);
      if (lastObjects) {
        let lastObject = lastObjects[0];
        this.updateSalarybreckupID = lastObject.id;
        this.selectedOptionSalaryBreakUp = lastObject?.isSalaryBreakup ? 'Yes' : 'No'
        this.selectedOptionForAppoinmentLetter = lastObject?.isAppointment ? 'Yes' : 'No'
        this.httpService.selectedOptionSalaryBreakUp = lastObject?.isSalaryBreakup;
        this.httpService.selectedOptionForAppoinmentLetter = lastObject?.isAppointment;
        console.log(this.httpService.selectedOptionForAppoinmentLetter);

        this.httpService.notcompletedElcmSetUp = this.hasInvalidCode || !this.selectedOptionSalaryBreakUp || !this.selectedcodecreateOption || !this.letterheadFilleFromBackendSide;
        let commanArray = [
          { "probation": this.hasInvalidCode },
          { "salary": lastObject },
          { "employeecode": this.getEmployeeCodeDataList },
          { "letterHead": this.letterheadFilleFromBackendSide }
        ];

        this.httpService.setnotcompletdSetUP(commanArray);
      }
    })
  }
  saveData() {
    if (this.selectedcodecreateOption == 'auto') {

      if (this.setPrefix == null || (this.setPrefix == '')) {
        this.showToast('prefix required!', 'danger');
        return
      } else if (this.setLimit == null || (this.setLimit == '')) {
        this.showToast('set limit required!', 'danger');
        return
      } else if (this.selectedcodecreateOption == null || (this.selectedcodecreateOption == '')) {
        this.showToast('selected code create option is required!', 'danger');
        return
      }
    }
    let formData = {
      // "id":this.getEmployeeCodeDataList?this.getEmployeeCodeDataList.id:null,
      "companyPrefix": this.setPrefix,
      "startNumber": this.setLimit,
      "employeeCodeSelection": this.selectedDeptLocation == 'none' ? null : this.selectedDeptLocation,
      "hrId": this.loggedInUserId,
      // "changeByUserId":this.loggedInUserId,
      "companyId": this.loggedInUserCompanyID,
      "isManual": this.selectedcodecreateOption == 'auto' ? false : true,
      // "fiscalYear": this.loggedInCompanyFiscalyear,
      "year": this.selectedYearForCompetency
    }
    let updateFromData = {
      "companyPrefix": this.setPrefix
    }
    if (this.getEmployeeCodeDataList.length == 0) {

      this.httpService.callPostService(`${this.config.employeeCodeCreate}`, formData).subscribe((data: any) => {


        if (data) {

          // Success popup
          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: "Added Successfully",
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });

          // Handle the result of the dialog
          dialogRef.afterClosed().subscribe(() => {
            this.dialogRef.close();
          });
          this.getAllEmployeeCodeData();
        }
      },
        (error: any) => {

          const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: error.error.error || 'An error occurred while processing your request. Please try again.',
              btn2: 'OK',
              btn2BgColor: 'red', // Highlight error with red button color
              showSuccessIcon: false,
              showSuccessMessage: false,
              showCloseIcon: true
            }
          });

          errorDialogRef.afterClosed().subscribe(() => {
            // Optionally handle any action after closing the error dialog
            console.log('Error dialog closed');
          });
        }
      );
    } else {
      this.httpService.callPutService(`${this.config.employeeCodeUpdate}/${this.getEmployeeCodeDataList.companyCodeId}`, updateFromData).subscribe((data: any) => {


        if (data) {

          // Success popup
          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: data.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });

          // Handle the result of the dialog
          dialogRef.afterClosed().subscribe(() => {
            this.dialogRef.close();
          });
          this.getAllEmployeeCodeData();
        }
      },
        (error: any) => {

          const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: error.error.error || 'An error occurred while processing your request. Please try again.',
              btn2: 'OK',
              btn2BgColor: 'red', // Highlight error with red button color
              showSuccessIcon: false,
              showSuccessMessage: false,
              showCloseIcon: true
            }
          });

          errorDialogRef.afterClosed().subscribe(() => {
            // Optionally handle any action after closing the error dialog
            console.log('Error dialog closed');
          });
        }
      );
    }
  }



  onClickOpenCreateSurveyPopup(popupName: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.data = {
      popupName: popupName,
      data: this.getEmployeeCodeDataList
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(ElcmCreateEmailTempletComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {


    });
  }


  addDeptAndLoc(popupName: any) {
    console.log("this.getEmployeeCodeDataList", this.getEmployeeCodeDataList);

    if (!this.flagData) {
      const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: "Employee code dose not save",
          btn2: 'OK',
          btn2BgColor: 'red', // Highlight error with red button color
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: true
        }
      });
      return
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '60%';
    dialogConfig.data = {
      popupName: popupName,
      employeeData: this.getEmployeeCodeDataList,
      setLimit: this.setLimit,
      setPrefix: this.setPrefix,
      companyId: this.loggedInUserCompanyID,
      changeByUserId: this.loggedInUserId,
      year: this.selectedYearForCompetency,
      fiscalYear: this.loggedInCompanyFiscalyear,
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(AddDeptLocComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {


    });

    // -------------------------For Department-----------------------------------


    // --------------------------End Department----------------------------------







  }
  //------------------------------------------------------upload File-----------------------------------------------------


  getIncrementFyYearList: any = []
  FormYear: any
  ToYear: any
  fileName: any = null;
  fileType: any = null;
  formData: any = new FormData();
  formDataForSign: any = new FormData();
  formDataForletterHead: any = new FormData();
  selectedYear: any;
  companyYears: any[] = [];

  letterHeadUrl: any;
  isDisabled: boolean = false;
  isFileSizeIsInvalid: boolean = false;
  isIncrementLetterCreateContent: any = false
  showBrowseBtn: boolean = false;
  showSignBrowseBtn: boolean = false;

  getUploadIncrementPolicyYear: any = []
  isDisabledUploadPolicyBtn: boolean = true;
  typeofupload: any;
  showletterHeadBrowseBtn: boolean = false;

  //   onFileSelected(event: Event) {

  //     const inputEvent: any = event.target as HTMLInputElement;
  //     this.fileName = null;
  //     this.fileType = null;
  //     this.fileContent = null;
  //     this.formData = new FormData();
  //     const fileSizeInKB = inputEvent.files[0].size / 1024;
  //     const fileSizeInMB = fileSizeInKB / 1024;
  //     if (!inputEvent.files[0] || inputEvent.files[0].length == 0) {
  //       return;
  //     }
  //     if (inputEvent.files[0].name.includes('csv') && !inputEvent.files[0].name.includes('CSV') && !inputEvent.files[0].name.includes('xlsx') && !inputEvent.files[0].name.includes('XLSX')) {
  //       window.alert("File format is not supported");
  //       return;
  //     }
  //     if (fileSizeInMB > 10) {
  //       window.alert("File size is greater than 10MB");
  //       return;
  //     }
  //     if (inputEvent.files[0]) {
  //       this.fileName = inputEvent.files[0].name;
  //       this.fileType = inputEvent.files[0].type;
  //       this.formData = new FormData();
  //       this.formData.append('file', inputEvent.files[0]);
  //       this.formData.append('companyId', this.loggedInUserCompanyID);
  //       this.showBrowseBtn = true;
  //       this.isDisabledUploadPolicyBtn = false;
  //       this.isFileSizeIsInvalid = false;

  //       // Read the file content
  //       const reader = new FileReader();
  //       reader.onload = () => {
  //         this.fileContent = reader.result; // Store the file content in memory
  //       };
  //       reader.onerror = () => {
  //         window.alert("Error reading the file");
  //       };
  //       reader.readAsArrayBuffer(inputEvent.files[0]); // Read file content as ArrayBuffer

  //     const url = this.config.uploadFileLocally + `?fileName=${this.fileName}&fileType=${this.fileType}`;
  //     this.httpService.submitFormService(url, this.formData).subscribe((data: any) => {
  //       this.letterHeadUrl = data?.data;
  //     })
  //   }
  // }

  triggerFileInput(event: any) {
    this.typeofupload = event;
    const fileInput = document.querySelector('#browseImage') as HTMLInputElement;
    if (fileInput) {
      fileInput.click(); // Programmatically trigger the click event
    }

  }

  fileContent: any;
  isDragging: boolean = false; // Track drag state

  onDragOver(event: DragEvent) {
    event.preventDefault(); // Prevent the default browser behavior
    this.isDragging = true; // Indicate that the file is being dragged
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false; // Reset the drag state
  }

  onFileDropped(event: DragEvent) {
    event.preventDefault();
    this.isDragging = false; // Reset the drag state

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.handleFile(files[0]); // Process the first file
    }
  }

  onFileSelected(event: Event) {
    const inputEvent = event.target as HTMLInputElement;
    if (inputEvent.files && inputEvent.files.length > 0) {
      this.handleFile(inputEvent.files[0]); // Process the selected file
    }
  }


  // For sign drag and drop 

  triggerFileInputSign() {

    const fileInput = document.querySelector('#browseSignImage') as HTMLInputElement;
    if (fileInput) {
      fileInput.click(); // Programmatically trigger the click event
    }

  }
  isDraggingSign: boolean = false;
  onDragOverSing(event: DragEvent) {
    console.log(event);

    event.preventDefault(); // Prevent the default browser behavior
    this.isDraggingSign = true; // Indicate that the file is being dragged
  }

  onDragLeaveSign(event: DragEvent) {
    event.preventDefault();
    this.isDraggingSign = false; // Reset the drag state
  }

  onFileDroppedSign(event: DragEvent) {
    event.preventDefault();
    this.isDraggingSign = false; // Reset the drag state

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.handelSignFile(files[0]); // Process the first file
    }
  }
  checkupload: any;
  onFileSelectedForSign(event: Event, item: any) {
    this.checkupload = item;
    const inputEvent = event.target as HTMLInputElement;


    if (inputEvent.files && inputEvent.files.length > 0) {
      this.handelSignFile(inputEvent.files[0]); // Process the selected file
    }

  }


  // For company letter head drag and drop 
  triggerFileInputcomapneletterhead() {

    const fileInput = document.querySelector('#browsecompanyletterheadImage') as HTMLInputElement;
    if (fileInput) {
      fileInput.click(); // Programmatically trigger the click event
      console.log(fileInput);

    }

  }

  isDraggingletterHead: boolean = false;
  onDragOverletterHead(event: DragEvent) {
    console.log(event);

    event.preventDefault(); // Prevent the default browser behavior
    this.isDraggingletterHead = true; // Indicate that the file is being dragged
  }

  onDragLeaveLetterHead(event: DragEvent) {
    event.preventDefault();
    this.isDraggingletterHead = false; // Reset the drag state
  }

  onFileDroppedLetterHead(event: DragEvent) {
    event.preventDefault();
    this.isDraggingletterHead = false; // Reset the drag state

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.handelletterHeadFile(files[0]); // Process the first file
    }
  }
  onFileSelectedForletterHead(event: Event) {



    // Check file type and extension
    const inputEvent = event.target as HTMLInputElement;
    console.log(inputEvent);

    if (inputEvent.files && inputEvent.files.length > 0) {
      this.handelletterHeadFile(inputEvent.files[0]); // Process the selected file
      this.letterheadfileNameForApiAppend = inputEvent.files[0];
      // this.letterheadFilleFromBackendSide = inputEvent.files[0].name

    }

  }
  handleFile(file: File) {
    const fileSizeInKB = file.size / 1024;
    const fileSizeInMB = fileSizeInKB / 1024;

    // Check file type and extension
    if (!file.name.match(/\.(csv|CSV|xlsx|XLSX|pdf|PDF|png|PNG|jpg|JPG|jpeg|JPEG)$/)) {
      window.alert("File format is not supported");
      return;
    }


    if (fileSizeInMB > 10) {
      window.alert("File size is greater than 10MB");
      return;
    }


    // File is valid
    this.fileName = file.name;
    this.fileType = file.type;
    this.formData = new FormData();
    this.formData.append('file', file);
    this.formData.append('companyId', this.loggedInUserCompanyID);
    this.showBrowseBtn = true;
    this.isDisabledUploadPolicyBtn = false;
    this.isFileSizeIsInvalid = false;

    // Optional: Read file content
    const reader = new FileReader();
    reader.onload = () => {
      this.fileContent = reader.result; // Store the file content
    };
    reader.readAsArrayBuffer(file); // Read the file as binary data

    //   const url = this.config.uploadFileLocally + `?fileName=${this.fileName}&fileType=${this.fileType}`;
    // this.httpService.submitFormService(url, this.formData).subscribe((data: any) => {
    //   this.letterHeadUrl = data?.data;
    // })
  }

  getYearSetup(event: any) {
    this.selectedYearForCompetency = event.value;
    this.getBAndAndGrade();

    this.getAllEmployeeCodeData();
    this.getprobationPeriods();
    this.getConfirmation();


  }
  handelSignFile(file: File) {
    const fileSizeInKB = file.size / 1024;
    const fileSizeInMB = fileSizeInKB / 1024;

    // Check file type and extension
    if (!file.name.match(/\.(csv|CSV|xlsx|XLSX|pdf|PDF|png|PNG|jpg|JPG|jpeg|JPEG)$/)) {
      window.alert("File format is not supported");
      return;
    }


    if (fileSizeInMB > 10) {
      window.alert("File size is greater than 10MB");
      return;
    }


    this.signfileName = file.name;
    this.signfileType = file.type;
    this.formDataForSign = new FormData();
    this.formDataForSign.append('file', file);
    this.formDataForSign.append('companyId', this.loggedInUserCompanyID);
    this.showSignBrowseBtn = true;
    this.isDisabledUploadPolicyBtn = false;
    this.isFileSizeIsInvalid = false;

    // Optional: Read file content
    const signreader = new FileReader();
    signreader.onload = () => {
      this.signContent = signreader.result; // Store the file content
    };
    signreader.readAsArrayBuffer(file); // Read the file as binary data



  }
  letterheadfileNameForApiAppend: any;
  handelletterHeadFile(file: File) {
    const fileSizeInKB = file.size / 1024;
    const fileSizeInMB = fileSizeInKB / 1024;

    console.log("Selected File:", file.name, "Type:", file.type); // Debugging

    // ❌ Strictly disallow .xlsx and .xls files
    if (file.name.match(/\.(xlsx|xls)$/i)) {
      window.alert("Excel files are not allowed.");
      return;
    }

    // ✅ Allowed file types: Only DOC and PDF
    if (!file.name.match(/\.(doc|docx|pdf)$/i)) {
      window.alert("Only DOC and PDF files are allowed.");
      return;
    }

    // ✅ File size check (Limit: 10MB)
    if (fileSizeInMB > 10) {
      window.alert("File size is greater than 10MB.");
      return;
    }

    // ✅ Reset FormData before appending
    this.formDataForletterHead = new FormData();

    this.letterheadfileName = file.name;
    this.letterheadFilleFromBackendSide = file.name;
    this.letterheadfileType = file.type;

    // ✅ Append file data to FormData
    this.formDataForletterHead.append('file', file);
    this.formDataForletterHead.append('companyId', this.loggedInUserCompanyID);

    this.showletterHeadBrowseBtn = true;
    this.isDisabledUploadPolicyBtn = false;
    this.isFileSizeIsInvalid = false;

    console.log("Final FormData:", this.formDataForletterHead);

    // ✅ Read file content
    const letterHeadreader = new FileReader();
    letterHeadreader.onload = () => {
      this.letterContent = letterHeadreader.result; // Store file content
    };
    letterHeadreader.readAsArrayBuffer(file); // Read the file as binary data
  }


  onClickCancelUploadPolicy() {
    this.showBrowseBtn = false;
    this.isDisabledUploadPolicyBtn = true;
  }

  onClickCancelUploadSign() {
    this.showSignBrowseBtn = false;
    this.isDisabledUploadPolicyBtn = true;
  }

  onClickUploadPolicy() {

    // Ensure the file is valid
    if (!this.letterheadfileNameForApiAppend) {
      console.error("File is missing!");
      return;
    }

    // Create FormData
    const formData = new FormData();
    formData.append("file", this.letterheadfileNameForApiAppend); // Append file
    formData.append("fileFor", "Offer letter");
    formData.append("companyId", this.loggedInUserCompanyID);
    formData.append("candidateId", "");
    formData.append("uploadByUserId", String(this.loggedInUserId));
    formData.append("fiscalYear", this.loggedInCompanyFiscalyear);
    formData.append("year", this.selectedYearForCompetency);

    formData.forEach((value, key) => {
      console.log(`${key}:`, value);
    });
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Letter head successfully uploaded.',
        btn2: 'Done',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: true,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.httpService.submitFormService(this.config.uploadOfferLetter, formData).subscribe((result: any) => {
          if (result) {
            this.showBrowseBtn = false;
            this.isDisabledUploadPolicyBtn = true;
            this.dialog.closeAll();
            this.getUploadLetterHead();
          }
        })
      }
    });
  }
  letterheadFilleFromBackendSide: any;
  filleFromBackendSide: any;
  getUploadLetterHead() {
    this.httpService.callGetService(this.config.getOfferLetter + this.loggedInUserCompanyID)
      .subscribe((result: any) => {
        console.log(result.data);

        if (result && result.data && result.data !== "null") { // Check for string "null"
          this.letterheadFilleFromBackendSide = result.data; // Assign valid data
          this.filleFromBackendSide = result.data
          this.showletterHeadBrowseBtn = true;
        } else {
          this.letterheadFilleFromBackendSide = ''; // Ensure it's empty if "null" or actually null
          this.showletterHeadBrowseBtn = false;
        }

        this.cdr.detectChanges(); // Ensure UI updates
      });
  }

  onClickCancelUploadletterHead(letterHead: any) {

    if (this.filleFromBackendSide) {

      this.httpService.callDeleteService(`${this.config.deleteLetterHead}?fileName=${letterHead}&companyId=${this.loggedInUserCompanyID}`)
        .subscribe((result: any) => {
          if (result) {

            // Success popup
            const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: result.message,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              }
            });

            // Handle the result of the dialog
            dialogRef.afterClosed().subscribe(() => {
              this.getUploadLetterHead();
            });

          }
        })
    } else {
      this.showletterHeadBrowseBtn = false;
      this.isDisabledUploadPolicyBtn = true;
    }
  }
  viewDocument(fileUrl: string): void {

    if (this.letterheadFilleFromBackendSide) {
      // Open the document in a new tab
      fileUrl = `${this.config.downloadFile}${this.letterheadFilleFromBackendSide}`;
      window.open(fileUrl, '_blank');
    } else {
      console.error('No document URL available');
    }
  }


  // Function to download the uploaded file
  downloadFile(event: any) {
    var blob: any;
    if (event == 'appoinmentLetter') {

      if (!this.fileName || !this.fileType || !this.fileContent) {
        window.alert('No file to download');
        return;
      }

      blob = new Blob([this.fileContent], { type: this.fileType });
      const downloadUrl = URL.createObjectURL(blob);

      const anchor = document.createElement('a');
      anchor.href = downloadUrl;
      anchor.download = this.fileName;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);

      URL.revokeObjectURL(downloadUrl);
    } else if (event == 'sign') {
      if (!this.signfileName || !this.signfileType || !this.signContent) {
        window.alert('No file to download');
        return;
      }

      blob = new Blob([this.signContent], { type: this.signfileType });
      const downloadUrl = URL.createObjectURL(blob);

      const anchor = document.createElement('a');
      anchor.href = downloadUrl;
      anchor.download = this.signfileName;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);

      URL.revokeObjectURL(downloadUrl);
    }
    else if (event == 'companyletterhead') {
      if (!this.letterheadfileName || !this.letterheadfileType || !this.letterContent) {
        window.alert('No file to download');
        return;
      }

      blob = new Blob([this.letterContent], { type: this.letterheadfileType });
      const downloadUrl = URL.createObjectURL(blob);

      const anchor = document.createElement('a');
      anchor.href = downloadUrl;
      anchor.download = this.letterheadfileName;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);

      URL.revokeObjectURL(downloadUrl);
    }
  }
  //----------------------------------------------------------------------EmailBody-------------------------------------------------------

  // ---------------------------------------------------------probation and confirmation-----------------------------------------------------

  employeetendAccrossyear: any = []
  probstionPriodsData: any = []
  getBAndAndGrade() {
    this.httpService.callGetService(`${this.config.getBandAndGradeForProbation}?companyId=${this.loggedInUserCompanyID}`)
      .subscribe((record: any) => {
        console.log(record);
        // let filterData=record.data.filter((elm:any)=>elm.userId==this.loggedInUserId)
        this.employeetendAccrossyear = record.data.map((item: any) => {
          return {
            ...item,
            grades: item.grades.map((grade: any) => ({
              band: item.band,
              grade: grade,
              probationPeriod: null, // Assign probationPeriod at the grade level
              extensionPeriod: null
            }))
          };
        });
        this.getprobationPeriods()
      });
  }

  getprobationPeriods() {
    this.httpService.callGetService(`${this.config.getProbation}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency}`)
      .subscribe((record: any) => {
        console.log("API Response:", record);

        this.probstionPriodsData = this.employeetendAccrossyear?.map((bandItem: any) => {
          return {
            ...bandItem,
            grades: bandItem.grades.map((gradeItem: any) => {
              const matchGrade = record.data.find((data: any) => data.grade === gradeItem.grade && data.band === gradeItem.band);
              return {
                ...gradeItem,
                probationId: matchGrade ? matchGrade.probationId : null,
                probationPeriod: matchGrade ? matchGrade.probationPeriod : null,
                extensionPeriod: matchGrade ? matchGrade.probationExtensionPeriod : null,
              };
            })
          };
        });

        console.log("Updated probation data:", this.probstionPriodsData);
      });
  }


  editableIndex: number | null = null;
  editableSubIndex: number | null = null;
  selectedOptionForConfirmation: any;
  gradeData: any;
  noOfDaysConfirmation: any;
  probationSetupId: any;
  editFlagForConfirm: boolean = false
  // Function to enable edit mode
  onClickEdit(i: number, j: number) {
    this.editableIndex = i;
    this.editableSubIndex = j;
  }

  // Function to close edit mode
  onClickClose() {
    this.editableIndex = null;
    this.editableSubIndex = null;
    this.gradeData = null
    this.editFlagForConfirm = false;
    this.getprobationPeriods();
  }
  onClickEditConfirm() {
    this.editFlagForConfirm = true
  }
  onClickCloseForDays() {
    this.getConfirmation();
    this.editFlagForConfirm = false;
  }
  cancelData() { }
  onSelectionChangeConfirmation(event: any) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: `Are you sure you want to select "${event}"?`,
        btn2: 'Yes',
        btn1: 'No',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {

      if (result) {
        this.selectedOptionForConfirmation = event;

        this.saveConfirmation();

      } else {
        this.selectedOptionForConfirmation = null;
      }
    });
  }
  getconfirmationdata: any = [];
  getConfirmation() {
    this.httpService.callGetService(`${this.config.getConfirmationSetUp}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYearForCompetency}`)
      .subscribe((record: any) => {
        this.getconfirmationdata = record.data;
        this.selectedOptionForConfirmation = record?.data[0]?.probationCurrentLogUserType || record?.data[1]?.probationCurrentLogUserType;
        this.probationSetupId = record?.data[0]?.probationSetupId || null;
        this.noOfDaysConfirmation = record?.data[0]?.noOfDayBeforeConfirmation;
        this.httpService.confirmationProbationWhomSetup = this.selectedOptionForConfirmation;


      })
  }


  saveConfirmation() {
    let a = this.selectedOptionForConfirmation == null || this.selectedOptionForConfirmation == "";
    let b = this.noOfDaysConfirmation == null || this.noOfDaysConfirmation == ""
    if (a) {
      this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: 'Confirmation/probation extention intimation email to whom setup Pending',
          btn2: 'OK',
          btn2BgColor: 'red', // Highlight error with red button color
          showSuccessIcon: false,
          showSuccessMessage: false
        }
      });
      return; // Stops further iteration
    }
    if (b && this.probationSetupId) {
      this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: 'No of days is required',
          btn2: 'OK',
          btn2BgColor: 'red', // Highlight error with red button color
          showSuccessIcon: false,
          showSuccessMessage: false
        }
      });
      return; // Stops further iteration
    }
    let fromdata = {
      "probationSetupId": this.probationSetupId || null,
      "hrId": this.loggedInUserId,
      "companyId": this.loggedInUserCompanyID,
      "year": this.selectedYearForCompetency,
      "fiscalYear": this.loggedInCompanyFiscalyear,
      "probationCurrentLogUserType": this.selectedOptionForConfirmation,  // 1.LINE_MANAGER 2.HOD  // This should be one of the enum values
      "noOfDayBeforeConfirmation": this.noOfDaysConfirmation
    }
    this.httpService.callPostService(`${this.config.saveConfirmationSetUp}`, fromdata)
      .subscribe((data: any) => {

        if (data) {

          // Success popup
          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: data.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });

          // Handle the result of the dialog
          dialogRef.afterClosed().subscribe(() => {
            this.getConfirmation();
          });
          this.editFlagForConfirm = false;
        }
      },
        (error: any) => {

          const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: error.error.error || 'An error occurred while processing your request. Please try again.',
              btn2: 'OK',
              btn2BgColor: 'red', // Highlight error with red button color
              showSuccessIcon: false,
              showSuccessMessage: false,
              showCloseIcon: true
            }
          });

          errorDialogRef.afterClosed().subscribe(() => {
            // Optionally handle any action after closing the error dialog
            console.log('Error dialog closed');
          });
        }
      )

  }

  addprobationPeriods(item: any, grade: any) {
    console.log(item);
    console.log(grade);
    this.gradeData = grade;

  }
  loading: boolean = false;
  isSubmitting: boolean = false;
  saveprobationPeriods() {
    if (!this.gradeData?.probationPeriod) {
      this.openErrorDialog('Probation period is required');
      return;
    }

    if (this.isSubmitting) return; // Prevent multiple clicks
    this.isSubmitting = true; // Set flag to true

    let formData = {
      probationId: this.gradeData?.probationId || null,
      hrId: this.loggedInUserId,
      companyId: this.loggedInUserCompanyID,
      year: this.selectedYearForCompetency,
      fiscalYear: this.loggedInCompanyFiscalyear,
      band: this.gradeData?.band,
      grade: this.gradeData?.grade,
      probationPeriod: this.gradeData?.probationPeriod,
      probationExtensionPeriod: this.gradeData?.extensionPeriod
    };

    this.loading = true;

    this.httpService.callPostService(`${this.config.saveBandAndGradeForProbation}`, formData)
      .subscribe({
        next: (data: any) => {
          this.isSubmitting = false; // Reset flag after response
          this.loading = false;

          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: this.gradeData?.probationId ? "Updated Successfully" : "Added Successfully",
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });

          dialogRef.afterClosed().subscribe(() => {
            this.getprobationPeriods();
          });

          this.onClickClose(); // Close edit mode
        },
        error: (error: any) => {
          this.isSubmitting = false; // Reset flag on error
          this.loading = false;

          this.openErrorDialog(error.error?.error || 'An error occurred while processing your request.');
        }
      });
  }

  // ✅ Reusable Error Dialog Function
  openErrorDialog(message: string) {
    this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: message,
        btn2: 'OK',
        btn2BgColor: 'red', // Red color for errors
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
  }
  checkLineManagerAndHod: any;
  currentemployeesProbationDetails: any
  checkLineManagerAndHodForConfirm: any;
  checkForSameHODORMANAGER() {
    this.httpService.callGetService(`${this.config.getProbationDetails}?companyId=${this.loggedInUserCompanyID}&yearRange=${this.selectedYearForCompetency}&fiscalType=${this.loggedInCompanyFiscalyear}`).subscribe((record: any) => {

      this.currentemployeesProbationDetails = record?.data;
      console.log(record);

      this.checkLineManagerAndHod = this.currentemployeesProbationDetails?.filter((record: any) => (record.hodCode == record.reportingManagerCode || record.reportingManagerCode == this.loggedInUserEmpCode))
      console.log(this.checkLineManagerAndHod)

    })
    this.httpService.callGetService(`${this.config.getProbationDetailsConfirmationEmployee}/${this.loggedInUserCompanyID}`)
      .subscribe((response: any) => {
        if (!response || !response?.data) return;

        let currentemployeesProbationDetails = response.data
        this.checkLineManagerAndHodForConfirm = currentemployeesProbationDetails?.filter((record: any) => (record.hodCode == record.reportingManagerCode || record.reportingManagerCode == this.loggedInUserEmpCode))
      })

  }
  get shouldShowContainer(): boolean {
    const isValidRole =
      (this.loggedInUserRole === 'Manager' && this.selectedOptionForConfirmation === 'HOD') ||
      (this.loggedInUserRole === 'HOD' && this.selectedOptionForConfirmation === 'LINE_MANAGER');

    return isValidRole && (this.checkLineManagerAndHod?.length > 0 || this.checkLineManagerAndHodForConfirm.length > 0);
  }

}
